import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-74c68be6"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "callback"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "登录中，请稍后...", -1));

const _hoisted_3 = [_hoisted_2];
import { useRoute } from 'vue-router';
import useUserStore from '@/store/modules/user.js';
export default {
  __name: 'callback',

  setup(__props) {
    const router = useRoute();
    const userStore = useUserStore();
    userStore.verifyTicket(router.query);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3);
    };
  }

};